import React from 'react';

const TrendIcon = (width,height,color) =>
    <svg xmlns='http://www.w3.org/2000/svg' width={width ? width:'25'} height={height ? height:'25'} viewBox='5 5 40 40' fill={color ? color:'#fff'}>
        <path d='M4.45 35.55 2 33.75l9.4-15 6 7 7.95-12.9 5.45 8.1q-.8.1-1.55.325t-1.5.525l-2.25-3.45-7.65 12.45-6.05-7.05ZM43.85 46l-6.7-6.7q-1.05.75-2.275 1.15-1.225.4-2.525.4-3.55 0-6.025-2.475Q23.85 35.9 23.85 32.35q0-3.55 2.475-6.025Q28.8 23.85 32.35 23.85q3.55 0 6.025 2.475Q40.85 28.8 40.85 32.35q0 1.3-.425 2.525Q40 36.1 39.3 37.2l6.7 6.65Zm-11.5-8.15q2.3 0 3.9-1.6t1.6-3.9q0-2.3-1.6-3.9t-3.9-1.6q-2.3 0-3.9 1.6t-1.6 3.9q0 2.3 1.6 3.9t3.9 1.6Zm3.7-16.4q-.75-.3-1.55-.4-.8-.1-1.65-.2L43.55 4 46 5.8Z'/>
    </svg>;

export default TrendIcon;
